import { isPublicAuthPath } from './publicPaths';

/**
 * Where to go after the next sign-in rides in the login URL itself:
 * /login?redirectTo=%2Fcounters. Every place that kicks a tab to /login builds
 * the URL with loginPathFor(); every post-login navigate reads it back with
 * redirectTargetFrom(). Nothing is stored — the URL is the memory, per tab by
 * nature (each tab navigates itself), reload-proof, and shareable as a deep
 * link.
 */
const PARAM = 'redirectTo';

/** Is `target` a same-origin path we are willing to redirect to after login? */
function isSafeTarget(target: string): boolean {
  // Rooted, single slash: rejects absolute URLs (https://…), scheme-relative
  // //evil.com, /\evil.com (browsers treat \ as /), and unrooted values.
  if (!target.startsWith('/')) return false;
  if (target.startsWith('//') || target.startsWith('/\\')) return false;
  // No loop back into the auth pages
  if (isPublicAuthPath(target.split('?')[0])) return false;
  return true;
}

/** The /login URL that remembers `path` (pathname + search). */
export function loginPathFor(path: string): string {
  if (path === '/' || !isSafeTarget(path)) return '/login';
  return `/login?${PARAM}=${encodeURIComponent(path)}`;
}

/** The route to land on after sign-in, read from a location search string. */
export function redirectTargetFrom(search: string): string {
  const target = new URLSearchParams(search).get(PARAM);
  if (target === null || !isSafeTarget(target)) return '/';
  return target;
}
